import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { isAuthSelector } from 'redux/store/slices/auth-slice'
import { stepSelector } from 'redux/store/slices/step-slice'

function ProtectedRoute() {
  const isAuthenticated = useSelector(isAuthSelector)

  if (!isAuthenticated) return <Navigate to={'/'} />
  return <Outlet />
}

export default ProtectedRoute
